/** faqs scrolling and open **/
document.addEventListener('DOMContentLoaded', () =>{
  var queryString = window.location.search;
  queryString = queryString.substring(1);
  var params = queryString.split("&");
  var paramsObject = {};
  for (var i = 0; i < params.length; i++) {
    var param = params[i].split("=");
    var paramName = decodeURIComponent(param[0]);
    var paramValue = decodeURIComponent(param[1]);
    paramsObject[paramName] = paramValue;
  }
  if (paramsObject["faq"]) {
     const faq = paramsObject["faq"].toLowerCase()
     if(document.querySelector("[data-que='"+faq+"'] button")){
      var offsetHeight = window.innerWidth < 768? 10:(document.querySelector("header").offsetHeight + 20)
       document.querySelector("[data-que='"+faq+"'] button").click()
       var targetElement = document.querySelector("[data-que='"+faq+"']")
        window.scrollTo({
          top: targetElement.offsetTop - offsetHeight,
          behavior: 'smooth',
        });
     }
  }
})

function formatMoney(money) {
  return Shopify.formatMoney(money, window.ShopifyCurrency.moneyFormat);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  // summary.setAttribute('role', 'button');
  // summary.setAttribute('aria-expanded', 'false');

  // if(summary.nextElementSibling.getAttribute('id')) {
  //   summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  // }

  // summary.addEventListener('click', (event) => {
  //   if(event.target.tagName.toLowerCase() != 'a') {
  //     event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  //   }
  // });

  // if(summary.dataset.nav == 'parent') {
  //   let isAnimating = false;
  //   const details = summary.closest('details');
  //   const megamenuContent = details.querySelector('.header__megamenu-content');
  //   const submenuBlocks = details.querySelectorAll('.header__submenu-block');
  
  //   // Function to reset submenu blocks to initial state
  //   const resetSubmenuBlocks = () => {
  //     submenuBlocks.forEach(block => {
  //       block.style.transitionDelay = '0s';
  //       block.style.opacity = '0';
  //       block.style.transform = 'translateX(-15px)';
  //     });
  //   };

  //   // Initialize blocks in starting position
  //   resetSubmenuBlocks();
  
  //   summary.parentElement.addEventListener('mouseover', (event) => {
  //     if (isAnimating) return;
      
  //     event.currentTarget.setAttribute('aria-expanded', 'true');
  //     details.setAttribute('open', '');
      
  //     // First show the container
  //     megamenuContent.style.opacity = '1';
  //     megamenuContent.style.transform = 'translateY(0)';
  //     megamenuContent.style.pointerEvents = 'auto';
      
  //     setTimeout(() => {
  //       // Then cascade the submenu blocks
  //       submenuBlocks.forEach((block, index) => {
  //         block.style.transitionDelay = `${index * 0.1}s`;
  //         block.style.opacity = '1';
  //         block.style.transform = 'translateX(0)';
  //       });
  //     }, 300);
  //   });
  
  //   summary.parentElement.addEventListener('mouseleave', (event) => {
  //     isAnimating = true;
      
  //     event.currentTarget.setAttribute('aria-expanded', 'false');

  //     // Then hide the container
  //     megamenuContent.style.opacity = '0';
  //     megamenuContent.style.transform = 'translateY(-100%)';
  //     megamenuContent.style.pointerEvents = 'none';
      
  //     // Reverse cascade the submenu blocks
  //     submenuBlocks.forEach((block, index) => {
  //       block.style.transitionDelay = `${(submenuBlocks.length - index - 1) * 0.05}s`;
  //       block.style.opacity = '0';
  //       block.style.transform = 'translateX(-15px)';
  //     });
    
      
  //     setTimeout(() => {
  //       details.removeAttribute('open');
  //       isAnimating = false;
        
  //       // Reset all submenu blocks to initial state
  //       resetSubmenuBlocks();
  //     }, 300);
  //   });
  // }

  // if (summary.closest('header-drawer')) return;
  // summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if(event.target.tagName.toLowerCase() != 'a' && window.innerWidth > 768) {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }
  });

  if(summary.dataset.nav == 'parent'){
    summary.parentElement.addEventListener('mouseover', (event) => {
      event.currentTarget.setAttribute('aria-expanded', 'true');
      event.currentTarget.closest('details').setAttribute('open', '');
    });
    summary.parentElement.addEventListener('mouseleave', (event) => {
      event.currentTarget.setAttribute('aria-expanded', 'false');
      event.currentTarget.closest('details').removeAttribute('open');
    });
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    
    const variantID = this.querySelector('input').getAttribute('variant-id');
    const hasMultipleItems = document.querySelectorAll(`.cart-item__block[data-variant-id="${variantID}"]`).length > 1;
    
    if (hasMultipleItems) {
      window.getCart().then(cartData => {
        if (!cartData) return;
        
        const cartQuantity = cartData.items
          .filter(item => item.variant_id === parseInt(variantID))
          .reduce((total, item) => total + item.quantity, 0);
        
        
        if (cartQuantity >= 9) {
          event.target.name === 'plus' ? null : this.input.stepDown();
        } else {
          event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        }
        
        if (cartQuantity !== this.input.value) {
          this.input.dispatchEvent(this.changeEvent);
        }
      }).catch(error => console.error('Error fetching cart:', error));
    } else {
      const previousValue = this.input.value;
      
      if (previousValue >= 9) {
        event.target.name === 'plus' ? null : this.input.stepDown();
      } else {
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      }
      
      if (previousValue !== this.input.value) {
        const event = new CustomEvent('change', {
          bubbles: true,
          cancelable: true,
          detail: { value: this.input.value }
        });
        
        this.input.dispatchEvent(event);
        return false; // Prevent default form submission
      }
    }
    
  }
}

customElements.define('quantity-input', QuantityInput);

class PdpquantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.input1 = document.querySelector('input[name="items[0][quantity]"]');
    this.input2 = document.querySelector('input[name="items[1][quantity]"]');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if(previousValue == 9) {
      event.target.name === 'plus' ? '' : this.input.stepDown();
    } else {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      if (this.input1) this.input1.value = this.input.value;
      if (this.input2) this.input2.value = this.input.value;
    }
  }
}

customElements.define('pdpquantity-input', PdpquantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class dropDownAnimation {
  shrink(detailsElement) {

    this.el = detailsElement;
    this.el.open = true;
    this.summary = detailsElement.querySelector("summary");
    this.content = detailsElement.querySelector(".drawer-content-wrapper")

    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in'
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false, this.el);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open(detailsElement) {
    // Apply a fixed height on the element
    this.el = detailsElement;
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand(this.el));
  }

  close(detailsElement) {
    // Apply a fixed height on the element
    this.el = detailsElement;

    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.shrink(this.el));
  }

  expand(detailsElement) {
    // Set the element as "being expanding"
    this.isExpanding = true;
    this.el = detailsElement;
    this.el.open = true;
    this.summary = this.el.querySelector("summary");
    this.content = this.el.querySelector(".drawer-content-wrapper")
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content?.offsetHeight }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 200,
      easing: 'ease-in'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true, this.el);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open, detailsElement) {
    this.el = detailsElement;
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.dropDownAnimation = new dropDownAnimation();
    this.mainDetailsToggle = this.querySelector('details');
    this.drawerOverlay = document.querySelector(".mobile-menu-overlay");

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.querySelector("#Details-menu-drawer-menu-item-1 summary")?.setAttribute("aria-expanded", "true");
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    detailsElement.style.overflow = 'hidden';
    const formElement = detailsElement.querySelector('facet-filters-form');
    formElement && (formElement.style.position = 'fixed');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if(event.target.tagName.toLowerCase() != 'a') {
        if (detailsElement.isClosing || !detailsElement.open) {
          this.dropDownAnimation.open(detailsElement);
        } else if (this.isExpanding || detailsElement.open) {
          this.dropDownAnimation.close(detailsElement);
        }
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.querySelector("summary").setAttribute("aria-expanded", "false");
      });
      // this.drawerOverlay.style.display = "none";
      //this.drawerOverlay.style.height = "0";
      this.drawerOverlay.style.opacity = "0";
      document.querySelector('#menu-drawer') .style.top = "100vh";
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.drawerOverlay = document.querySelector(".mobile-menu-overlay");
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('[id*="header"]');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--screen-available-height', window.innerHeight+"px");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    // this.drawerOverlay.style.display = "block";
    //this.drawerOverlay.style.height = "100%";
    this.drawerOverlay.style.opacity = "1";
    document.querySelector('#menu-drawer') .style.top = "calc(100% + 1px)";
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // this.clickedVariantID = [];
    this.switchimg = this.dataset.switchimg;
    this.initializeVariantPicker()
  }

  initializeVariantPicker() {
    document.querySelectorAll('.edit-variant:not(.loaded)').forEach(function(element) {
      element.classList.add("loaded");
      element.addEventListener('click', function(e) {
        let parent = element.closest('.cart-item__block');
        var nextSibling = parent.nextElementSibling;
        if (nextSibling.classList.contains('cart-item__variant-picker')) {
          let variantRadios = nextSibling.querySelector('variant-radios');
          if(variantRadios){
            variantRadios.updateCartNotification()
          }
          nextSibling.classList.add('variant-picker__expanded');
          return nextSibling; // Return the found element if needed
        }
        nextSibling = nextSibling.nextElementSibling;
      });
    });
  
    var variantPickerCloseButtons = document.querySelectorAll('.variant-picker__close');
    variantPickerCloseButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        let targetElement = e.target;
        let closestVariantPicker = targetElement.closest('.cart-item__variant-picker');
        closestVariantPicker.classList.remove('variant-picker__expanded');
        closestVariantPicker.querySelector(".active-variant__drawer").innerHTML = ""
      });
    });
  
    const activeVariants = document.querySelectorAll('.cart-item__active-variant');
    activeVariants.forEach((activeVariant, index) => {
      const drawer = activeVariant.nextElementSibling;
      if (drawer && (drawer.classList.contains('active-variant__drawer') || drawer.classList.contains('cust-active-variant__drawer-container'))) {
        if (!activeVariant.classList.contains('listener-added')) {
          activeVariant.addEventListener('click', () => {
            const close = activeVariant.querySelector('.active-variant__close');
            drawer.classList.toggle('open');
            close.classList.toggle('inverted');
          });
          activeVariant.classList.add('listener-added');
        }
      } else {
        console.error(`Drawer not found or does not have the correct class for Active Variant ${index}`);
      }
    });
    
    const customOptions = this.querySelectorAll(".cust-active-variant__drawer-item .cust-active-variant__drawer-option");
    customOptions.forEach((customOption) => {
       customOption.addEventListener('click', (e) => {
         this.querySelector(".cart-item__active-variant").click();
         const radios = this.querySelectorAll("input[name='"+customOption.dataset.inputName+"']")
         for (let radio of radios) {
           if(radio.value == customOption.dataset.inputValue){
              radio.click();  
              break;
           }
         }
      });
    })
    
    const variantUpdateButtons = document.querySelectorAll('.variant-update__btn');
    variantUpdateButtons.forEach((button) => {
      // Check if the event listener has already been added
      if (!button.hasAttribute('data-listener-added')) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          console.log('variant update button clicked');
  
          document.querySelector('.mini-cart-overlay').style.opacity = "1";
          document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";
  
          const variantId = button.getAttribute('data-variant-id');
          const lineItemKey = button.getAttribute('data-line-item-key');
          const lineItemIndex = button.getAttribute('data-line-item-index');
          const quantity = button.getAttribute('data-quantity');
  
          if (lineItemKey) {
            const removeData = {
              id: lineItemKey,
              quantity: 0
            };
  
            // Remove the existing line item
            fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(removeData)
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              const addData = {
                id: variantId,
                quantity: parseInt(quantity, 10)
              };
  
              // Add the new line item with the updated variant
              return fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(addData)
              });
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              const cartObj = document.querySelector('cart-notification');
              cartObj.renderContents();
            })
            .catch(error => {
              console.error('Request failed', error);
            });
          } else {
            const addData = {
              id: variantId,
              quantity: parseInt(quantity, 10),
              properties: {
                _source: 'cart-claim',
              }
            }
  
            // Add the new line item directly
            fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(addData)
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              let productId = data.product_id;
              let variant = data.variant_id;

              console.log('Updated cart', data);
              
              // Find all non-duplicate slides
              const nonDuplicateSlides = Array.from(document.querySelectorAll('.swiper-slide')).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
            
              // Find the button inside a non-duplicate slide
              let btn;
              let slideElement;
              for (let slide of nonDuplicateSlides) {
                btn = slide.querySelector(`button.cart-claim__button[data-product-id="${productId}"]`);
                if (btn) {
                  slideElement = slide;
                  break;
                }
              }

              const cartObj = document.querySelector('cart-notification');
              // Check if the original button does not contain the variant-update__nosto class
              if (!button.classList.contains('variant-update__nosto') && slideElement) {
                
                // Temporarily disable loop
                cartObj.swiperCartClaim.loopDestroy();
                
                // Calculate the correct index for the slide based on aria-label
                const ariaLabel = slideElement.getAttribute('aria-label');
                const slidePosition = parseInt(ariaLabel.split('/')[0], 10) - 1;
                
                // Save the slide element and its index in the Map
                cartObj.slideElementsMap.set(variant, { html: slideElement.outerHTML, index: slidePosition });
                
                // Remove the slide from the Swiper instance
                cartObj.swiperCartClaim.removeSlide(slidePosition);
                
                // Filter out duplicate slides
                const uniqueSlides = Array.from(cartObj.swiperCartClaim.slides).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
                
                // Check the number of unique slides
                if (uniqueSlides.length === 1) {
                  // Remove duplicate slides
                  const duplicateSlides = cartObj.swiperCartClaim.wrapperEl.querySelectorAll('.swiper-slide-duplicate');
                  duplicateSlides.forEach(slide => slide.remove());
                  
                  // Update Swiper without re-enabling the loop
                  cartObj.swiperCartClaim.update();
                } else {
                  // Re-enable loop and update Swiper
                  cartObj.swiperCartClaim.loopCreate();
                  cartObj.swiperCartClaim.update();
                }
              }

              cartObj.renderContents();

              if (button.classList.contains('upsell-btn')) {
                // Get the product ID from the button's data attribute
                const productId = button.getAttribute('data-product-id');
              
                // Find the corresponding select-shade-button using the product ID
                const selectShadeButton = document.querySelector(`.select-shade-button[data-product-id="${productId}"]`);
              
                if (selectShadeButton) {
                  // Change the button text to "Added"
                  selectShadeButton.textContent = 'Added';
              
                  // Disable the button
                  selectShadeButton.disabled = true;
                }
              }
            })
            .catch(error => {
              console.error('Request failed', error);
            });
          }
        });
  
        // Mark the button as having an event listener added
        button.setAttribute('data-listener-added', 'true');
      }
    });
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    const fieldset = this.querySelector('.product-form__input-color');
    const activeVariant = this.querySelector('input[type="radio"]:checked');
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderCartNotification();
      this.renderProductInfo();
      this.updateShareUrl();
      
      const isFloatingBar = this.closest('.custom-step');
      const isMainForm = this.closest('.product__info-container');
      
      if (isFloatingBar) {
        // Update main form
        const mainRadio = document.querySelector(`.product__info-container input[type="radio"][value="${activeVariant.value}"]`);
        if (mainRadio && !mainRadio.checked) {
          mainRadio.checked = true;
          mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (isMainForm) {
        // Update floating bar
        const floatingRadio = document.querySelector(`.custom-variant-options input[type="radio"][value="${activeVariant.value}"]`);
        if (floatingRadio && !floatingRadio.checked) {
          floatingRadio.checked = true;
          floatingRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }


      if (activeVariant) {
        // Find the associated label
        const associatedLabel = this.querySelector(`label[for="${activeVariant.id}"]`);
        const variantSwatch = this.querySelector('.active-variant__swatch');
        const variantTitle = this.querySelector('.active-variant__title');
        const variantContent = this.querySelector('.active-variant__content');

        const custOption =  this.querySelector(".cust-active-variant__drawer-option[data-input-value='"+activeVariant.value+"']");

        if(custOption){
          this.querySelector(".cust-active-variant__drawer-option.active").classList.remove("active");
          custOption.classList.add("active");
        }

        if (associatedLabel) {
          if(variantSwatch !== null && associatedLabel.style.backgroundColor) {
            variantSwatch.style.backgroundColor = associatedLabel.style.backgroundColor;
          } else {
            variantContent.querySelector('img').src = associatedLabel.querySelector('img').src;
          }
        } 
      
        if (variantTitle) {
          variantTitle.style.opacity = 0; // Start with opacity 0
          setTimeout(() => {            
            if (activeVariant.value.includes('-')) {
              // Split the variant name by the first dash
              const [firstPart, ...rest] = activeVariant.value.split('-');
              // Create spans for each part
              variantTitle.innerHTML = `
                <span class="active-variant__title-main">${firstPart.trim()}</span>
                <br>
                <span class="active-variant__title-sub">${rest.join('-').trim()}</span>
              `;
            } else {
              variantTitle.textContent = activeVariant.value;
            }
            
            variantTitle.style.opacity = 1; // Fade in to opacity 1
          }, 150); // Delay to match the transition duration
        }
      }

  }

  updateOptions() {
    const selectElements = this.querySelectorAll('select');
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const insideDrawer = this.parentElement && this.parentElement.classList.contains('variant-picker__content')
    const insideFloatingBar = this.parentElement.closest('.custom-variant-options')

    const variants = this.getVariantData();
    this.currentVariant = variants.find((variant) => {
      const matches = variant.options.map((option, index) => {
        return this.options[index] === option;
      });
      return !matches.includes(false);
    });
    
    if (insideDrawer) {
      this.parentElement.querySelector('.variant-update__btn').setAttribute('data-variant-id', this.currentVariant.id);
    } 

    if(insideFloatingBar) {
      this.closest('.custom-step').querySelector('.custom-add-to-cart-button').setAttribute('data-variant-id', this.currentVariant.id);
    }

  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`) // original

    // Get all parameters | custom by Inscoder solution from Elevar
    var pastParam = this._getAllParameters('variant');
    let appendParam = '';
    if (pastParam != '') {
      appendParam = `&${pastParam}`
    }

    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}${appendParam}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="items[0][id]"]');
      const input_id = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input_id.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input_id.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  handleizeString(str){
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  renderCartNotification() {
    const currentVarName = this.handleizeString(this.currentVariant.title);
    const productName = this.handleizeString(this.currentVariant.name);
    const cartItemVariant = this.closest('.cart-item__variant-picker');
    const pickerContent = this.closest('.variant-picker__content')
    if (!cartItemVariant) {
        return;
    }

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
         const html = new DOMParser().parseFromString(responseText, 'text/html');
        if(this.switchimg === 'false'){
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        } else {
          const soldBtn = html.querySelector(".product .product-form__submit.button--soldout");
          if(soldBtn){
            pickerContent.querySelector(".cart-notification__footer button").disabled = true;
          }else{
            pickerContent.querySelector(".cart-notification__footer button").disabled = false;
          }
          if(pickerContent.querySelector(".nosto-price")){
            pickerContent.querySelector(".nosto-price").innerHTML = formatMoney(this.currentVariant.price);
          }
          const optionvalueDestination = cartItemVariant.querySelector(`.product__case-refill`);
          if(optionvalueDestination){
            const optionvalueSource = html.querySelector(".product .product__case-refill");

            if (optionvalueSource && optionvalueDestination) optionvalueDestination.innerHTML = optionvalueSource.innerHTML;
          }

        }
      });
  }
  
  renderProductInfo() {
    const currentVarName = this.handleizeString(this.currentVariant.title);
    const productName = this.handleizeString(this.currentVariant.name);
    const productElement = this.closest('.product');
    
    if (!productElement) {
        return;
    }

    const $productSlider = productElement.querySelector('product-images-slider');
    const $sliderMain = $('.slider.slider-for', $productSlider);
    const $navSlider = $('.slider.slider-nav', $productSlider);
    var $this = this;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `#price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = productElement.querySelectorAll(id);
        const source = html.querySelectorAll(id);
        for (let index = 0; index < destination.length; index++) {
          if(source[index] && destination[index]){
            destination[index].innerHTML = source[index].innerHTML;
          }
        }

        const price = productElement.querySelector(`#price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        if(this.switchimg === 'false'){
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        } else {

          // addtocart / soldout / notify button | by Inscoder
          const ctaID = `product-form__buttons-${this.dataset.section}`;
          const ctaDestination = productElement.querySelector(`#${ctaID}`);
          const ctaSource = html.getElementById(ctaID);
          if (ctaSource && ctaDestination) ctaDestination.innerHTML = ctaSource.innerHTML;

          // trigger klaviyo popup of notify
          const klaviyoNotifyDummyBtn = productElement.querySelector('[data-action="klaviyonotify"]');
          const klaviyoNotifyBtn = productElement.querySelector('a.klaviyo-bis-trigger');
          if(klaviyoNotifyDummyBtn && klaviyoNotifyBtn){
            klaviyoNotifyDummyBtn.addEventListener('click', (event) => {
              klaviyoNotifyBtn.click();
            });
          }

          // selected variant display | by Inscoder
          const psvID = `psv-${this.dataset.section}`;
          const psvDestination = productElement.querySelector(`#${psvID}`);
          const psvSource = html.getElementById(psvID);
          if (psvSource && psvDestination) psvDestination.innerHTML = psvSource.innerHTML;

          //Update variant price
          const priceBlocks = document.querySelectorAll('.price-wrapper .block--price:not(.small-hide)');
          if (priceBlocks.length > 0 && price !== null) {
            priceBlocks.forEach(priceBlock => {
              // Find any price element within the block or its children
              const existingPrice = priceBlock.textContent.match(/[\d,]+\.?\d*/)?.[0] || '';
              if (!existingPrice) return;

              let priceString = this.currentVariant.price.toString();
              priceString = priceString.slice(0, -2) + '.' + priceString.slice(-2);
              
              // Get currency symbol by removing all numbers, dots, and commas
              const currencySymbol = priceBlock.textContent.replace(/[\d,\.]/g, '').trim().split(' ')[0];
              
              priceBlock.innerHTML = currencySymbol + priceString;
            });
          }

          //Update floating bar ATC button as sold out if variant is not available
          const floatingAddToCartButton = productElement.querySelector('.custom-add-to-cart-button');
          if (floatingAddToCartButton) {
            if (this.currentVariant.available) {
              floatingAddToCartButton.innerHTML = `
                <span class="button-text">
                  ${window.variantStrings.addToCart}
                </span>
                <div class="price-wrapper">
                  <div class="block--price">
                    <div class="no-js-hidden igPrice" data-variant-id="${this.currentVariant.id}">
                      ${formatMoney(this.currentVariant.price)}
                    </div>
                  </div>
                </div>
              `;
              // Re-enable main add to cart button
              floatingAddToCartButton.removeAttribute('disabled');
            } else {
              floatingAddToCartButton.innerHTML = `
                <span class="product-form__submit button button--full-width font-700 font-HelveticaNeue-Roman button--soldout" 
                  data-action="klaviyonotify" 
                  onclick="document.querySelector('a.klaviyo-bis-trigger').click();">
                  NOTIFY ME WHEN AVAILABLE
                </span>
              `;
              // Disable main add to cart button
              floatingAddToCartButton.setAttribute('disabled', 'disabled');
            }
          }
          
          // selected variant title for case-refill template | by Inscoder
          // const selectedVarinatTitle = productElement.querySelector(`.product-form__input-color`);
          // if(selectedVarinatTitle){
          //   const selectedVarinatTitleSource = html.querySelector(`.product-form__input-color`);
          //   (selectedVarinatTitle)
          //   if (selectedVarinatTitleSource) selectedVarinatTitle.innerHTML = selectedVarinatTitleSource.innerHTML;
          // }

          const optionvalueID = `caserefill-${this.dataset.section}`;
          if(optionvalueID){
            const optionvalueDestination = productElement.querySelector(`#${optionvalueID}`);
            const optionvalueSource = html.getElementById(optionvalueID);

            if (optionvalueSource && optionvalueDestination) optionvalueDestination.innerHTML = optionvalueSource.innerHTML;
          }

          const optionvalueFixedID = `caserefill-${this.dataset.section}-fixed`;
          if(optionvalueFixedID){
            const optionvalueDestination = productElement.querySelector(`#${optionvalueFixedID}`);
            const optionvalueSource = html.getElementById(optionvalueFixedID);

            if (optionvalueSource && optionvalueDestination) optionvalueDestination.innerHTML = optionvalueSource.innerHTML;
          }

          if(this.dataset.instanceIdentifier){
            const optionvalueID = `caserefill-${this.dataset.section}-${this.dataset.instanceIdentifier}`;
            const optionvalueDestination = productElement.querySelector(`#${optionvalueID}`);
            const optionvalueSource = html.getElementById(optionvalueID);
            if (optionvalueSource && optionvalueDestination) optionvalueDestination.innerHTML = optionvalueSource.innerHTML;
          }

          /* show selected color images + main slider filter | by inscoder */
          // Main slider
          $sliderMain.slick('unslick');
          const nextVarImagesID = `[data-slider="pi-${this.dataset.section}"] .slider-for`;
          const piDestination = $productSlider.querySelector(nextVarImagesID);
          const piSource = html.querySelector(nextVarImagesID);
          if (piSource && piDestination) piDestination.innerHTML = piSource.innerHTML;

          // Nav slider
          $navSlider.slick('unslick');
          const nextVarImagesNavID = `[data-slider="pi-${this.dataset.section}"] .slider-nav`;
          const piDestinationNav = $productSlider.querySelector(nextVarImagesNavID);
          const piSourceNav = html.querySelector(nextVarImagesNavID);
          if (piSourceNav && piDestinationNav) piDestinationNav.innerHTML = piSourceNav.innerHTML;

          // re-initialize the slider
          new ProductImagesSlider(currentVarName, productName);

          $sliderMain.slick('slickUnfilter');
          $sliderMain.slick('slickFilter', '[data-alt="'+ currentVarName +'"], [data-alt="'+ productName +'"], [data-alt^="*"]');

          $navSlider.slick('slickUnfilter');
          $navSlider.slick('slickFilter', '[data-alt="'+ currentVarName +'"], [data-alt="'+ productName +'"], [data-alt^="*"]');

          // update the product variantID for BuyXgetY promotion
          if(window.pmoBuyXgetYSettings.enable) {
            window.pmoBuyXgetYSettings.pmoProduct[0].varID = this.currentVariant.id;
          }


          const activeVariants = productElement.querySelectorAll(".cart-item__active-variant");
          activeVariants.forEach(item => {
            const optionvalueSource = html.querySelector(".product .cart-item__active-variant");
            item.innerHTML = optionvalueSource.innerHTML;
          })
          
          const floatingAddToCartPrice = productElement.querySelector('.custom-accordion-toggle__price');
          if (floatingAddToCartPrice) {
            floatingAddToCartPrice.innerHTML = formatMoney(this.currentVariant.price);
            floatingAddToCartPrice.dataset.variantId = this.currentVariant.id;
          }


          const reWidget = productElement.querySelectorAll("RECHARGE-SUBSCRIPTION-WIDGET");
          reWidget.forEach(item => {
            item.updateInput && item.updateInput()
          })
        }
      });
}

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  /* Get all Paramter */
  _getAllParameters(except='none') {
    var result = '',
      tmp = [],
      idx = 0;

    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if ((except == 'none') || (tmp[0] !== except)) {
          if (idx != 0) {
            result += '&';
          }
          idx++;
          if(tmp[1] != undefined)
            result += `${tmp[0]}=${decodeURIComponent(tmp[1])}`;
        }
      });
    return result;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    // case-refill template, select first variant of 2nd option
    const $this = this;
    const productSwatch1 = document.querySelectorAll(`body.product-case-refill [data-section="${$this.dataset.section}"] input[data-optionindex="1"]`);
    productSwatch1.forEach((rdo) => {
      rdo.addEventListener("change", function(){
        document.querySelectorAll(`body.product-case-refill [data-section="${$this.dataset.section}"] input[data-optionindex="2"]`)[0].click();
      })
    });
  }


  async updateCartNotification() {
    var response = await fetch(`${this.dataset.url}`)
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    this.querySelector(".active-variant__drawer").innerHTML = doc.querySelector(".product .active-variant__drawer").innerHTML
    // Set footer z-index to 9 when variant picker opens, overriding !important
    document.querySelector('.cart-notification__footer.footer__main').style.setProperty('z-index', '9', 'important');

    this.querySelector(".active-variant__drawer").classList.add("open")
    this.querySelector(".active-variant__close").classList.remove("inverted")
    this.initializeVariantPicker();
    const tabsContainer = this.querySelector('.shade-category-tabs');

    if (tabsContainer !== null){
        const tabs = tabsContainer.querySelectorAll('.shade-category-tab');
        const panels = this.querySelectorAll('.shade-category-panel');

        if (tabs.length > 0) {
          // Create highlight element
          const highlight = document.createElement('span');
          highlight.classList.add('tab-highlight');
          tabsContainer.appendChild(highlight);

          function setActiveTab(tab) {
            const category = tab.dataset.category;

            // Update tabs
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            // Update panels
            panels.forEach(panel => {
              panel.classList.toggle('active', panel.dataset.category === category);
            });

            // Move highlight
            const tabRect = tab.getBoundingClientRect();
            const containerRect = tabsContainer.getBoundingClientRect();

            // Calculate text width with uppercase transformation
            const textContent = tab.textContent.toUpperCase(); // Convert to uppercase
            const textWidth = getTextWidth(textContent, getComputedStyle(tab).font);

            highlight.style.width = `${textWidth}px`;
            highlight.style.left = `${tabRect.left - containerRect.left + (tabRect.width - textWidth) / 2}px`;
          }

          // Function to calculate text width
          function getTextWidth(text, font) {
            const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
            const context = canvas.getContext("2d");
            context.font = font;
            const metrics = context.measureText(text);
            return metrics.width;
          }

          tabs.forEach(tab => {
            tab.addEventListener('click', () => setActiveTab(tab));
          });

          // Set initial active tab
          if (tabs.length > 0) {
            setActiveTab(tabs[0]);
          }
        }

    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

  }
}

customElements.define('variant-radios', VariantRadios);

/* === Custom JS by Inscoder === */

// Footer Dropdown
(function () {
  class footerDropdown {
    constructor() {
      this.el = document.querySelector("footer")
      this.dropDownAnimation = new dropDownAnimation();
      window.addEventListener("resize", this.init);
      document.addEventListener("DOMContentLoaded", this.init);
      this.el.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    }
    init() {
      var footerDropdownElem = document.querySelectorAll(`.footer-block details`);
      if(window.innerWidth >= 750){
        footerDropdownElem.forEach((fDropdown) => {
          fDropdown.open = true;
        });
      }
      else{
        footerDropdownElem.forEach((fDropdown) => {
          fDropdown.open = false;
        });
      }
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;

      detailsElement.style.overflow = 'hidden';

      if (detailsElement.isClosing || !detailsElement.open) {
        this.dropDownAnimation.open(detailsElement);
      } else if (this.isExpanding || detailsElement.open) {
        this.dropDownAnimation.close(detailsElement);
      }
    }
  }
  new footerDropdown();
})();
var allQuestions = document.querySelectorAll('.faq_section dt');
if(allQuestions.length > 0){
  allQuestions.forEach(function(element,index){
    element.addEventListener("click", function(){
      if(element.querySelector('button').getAttribute("aria-expanded") == "true"){
        element.querySelector('button').setAttribute("aria-expanded", "false");
        element.nextElementSibling.setAttribute("aria-hidden","true");
        element.nextElementSibling.style.maxHeight = null;
      }else{
        element.querySelector('button').setAttribute("aria-expanded", "true");
        element.nextElementSibling.setAttribute("aria-hidden","false");
        element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 32 + "px";
      }
    });
  });
}

// Nosto carousel
class NostoCarousel extends HTMLElement{
  constructor(){
    super();
    // product price remove trailing .00
    var nostoItemPrices = this.querySelectorAll('.price-item')
    nostoItemPrices.forEach(nostoPrice => {
      nostoPrice.innerHTML = nostoPrice.innerHTML.replace('.00', '')
    })

    var nostoSwiperElem = this.querySelector('[data-carousel="nosto"]');
    var configDataString = nostoSwiperElem.getAttribute('data-swiper-config');
    var configData = JSON.parse(configDataString);

    var swiper = new Swiper(nostoSwiperElem, {
      slidesPerView: configData.phone,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
      breakpoints: {
        480: {
            slidesPerView: configData.tablet,
            spaceBetween: configData.spaceBetween
        },
        768: {
            slidesPerView: configData.desktop,
            spaceBetween: configData.spaceBetween
        },
      },
    });
  }
}
customElements.define('nosto-carousel', NostoCarousel);

// announcemnet carousel
class AnnouncementBarSlider extends HTMLElement{
  constructor(){
    super();

    var announcementSwiperElem = this.querySelector('[data-carousel="announcement"]');
    var configDataString = announcementSwiperElem.getAttribute('data-swiper-config');
    var configData = JSON.parse(configDataString);

    var swiper = new Swiper(announcementSwiperElem, {
      slidesPerView: configData.phone,
      spaceBetween: 0,
      loop: true,
      speed: Number(configData.speed),
      effect: configData.effect,
      autoHeight: configData.adaptiveHeight,
      autoplay: {
        delay: configData.delay,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: 'announcementbar-carousel .swiper-next',
        prevEl: 'announcementbar-carousel .swiper-prev',
      },
      breakpoints: {
        480: {
            slidesPerView: configData.tablet,
            spaceBetween: configData.spaceBetween
        },
        768: {
            slidesPerView: configData.desktop,
            spaceBetween: configData.spaceBetween
        },
      },
    });
  }
}
customElements.define('announcementbar-carousel', AnnouncementBarSlider);
// Nosto carousel
class SlideShow extends HTMLElement{
  constructor(){
    super();


    var slideShowElem = this.querySelector('[data-carousel="slideshow"]');
    var configDataString = slideShowElem.getAttribute('data-swiper-config');
    var configData = JSON.parse(configDataString);

    var swiper = new Swiper(slideShowElem, {
      slidesPerView: configData.phone,
      spaceBetween: 0,
      autoHeight: configData.adaptiveHeight,
      effect: configData.effect,
      loop: true,
      autoplay: {
        delay: configData.delay,
      },
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
      breakpoints: {
        480: {
            slidesPerView: configData.tablet,
            spaceBetween: configData.spaceBetween
        },
        768: {
            slidesPerView: configData.desktop,
            spaceBetween: configData.spaceBetween
        },
      },
      on: {
        init() {
          mediaHeight();
        }
      }
    });

    addEventListener('DOMContentLoaded', mediaHeight);
    addEventListener('resize', mediaHeight);

    function mediaHeight(){
      if (window.matchMedia("(max-width: 768px)").matches) {
        var activeSlide = slideShowElem.querySelector('.swiper-slide-active');
        var imgHeight = activeSlide.querySelector('.banner__media');
        var vidHeight = activeSlide.querySelector('.video-container');
        let mediaHeight;
        if(imgHeight){
          mediaHeight = imgHeight.clientHeight
        } else if(vidHeight){
          mediaHeight = vidHeight.clientHeight
        }
        slideShowElem.querySelectorAll('.swiper-nav').forEach((arrow) => {
          arrow.style.height = mediaHeight + 'px';
        })
      } else {
        slideShowElem.querySelectorAll('.swiper-nav').forEach((arrow) => {
          arrow.style.height = '100%';
        })
      }
    }

  }
}
customElements.define('slide-show', SlideShow);